import { HeaderNavItem } from "@shetharp/gatsby-theme-polaroid";

export const headerNavItems: HeaderNavItem[] = [
  {
    label: "Blog",
    slug: "/blog",
    isVisibleMobile: true,
    isVisibleTablet: true,
  },
  {
    label: "Readme",
    href: "/readme",
  },
  {
    label: "About",
    slug: "/about",
    isVisibleTablet: true,
  },
  {
    label: "Contact",
    slug: "/contact",
    isVisibleTablet: true,
  },
];
